import { spaces } from '@kimuno/theme';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { campaign, onboardingHints } from '../../constants';
import { selectUser } from '../../reducers/user.selectors';
import { ampliTrackMessageDisplayedEvent, MessageType } from '../../services/track.service';
import useOnboardingDialog from '../../utils/useOnboardingDialog';
import AlertDialog from '../Dialog/AlertDialog';
import useShouldShowAiOnlyWelcomeDialog from './useShouldShowAiOnlyWelcomeDialog';

const AiOnlyWelcomeDialog = () => {
	const { t } = useTranslation();
	const user = useSelector(selectUser);

	const { isShown, markDialogAsSeen } = useOnboardingDialog(onboardingHints.aiOnlyWelcomeDialog);
	const shouldShowDialog = useShouldShowAiOnlyWelcomeDialog();

	const closeDialog = () => {
		ampliTrackMessageDisplayedEvent(campaign.aiOnlyWelcomeMessage, MessageType.DIALOG, 1);
		markDialogAsSeen();
	};

	if (!shouldShowDialog) return null;

	return (
		<AlertDialog
			variant="text"
			open={!isShown}
			onClose={closeDialog}
			title={`${t('Welcome to meinUnterricht KI, {{firstName}}', { firstName: user?.firstName })} 👋`}
			description={
				<>
					{t('aiOnlyWelcomeIntro')}
					<Box
						component="ul"
						sx={{
							listStyle: 'none',
							paddingLeft: spaces.sm,
							marginTop: spaces.sm,
							marginBottom: 0,
						}}
					>
						<li>{t('aiOnlyWelcomeBullet1')}</li>
						<li>{t('aiOnlyWelcomeBullet2')}</li>
						<li>{t('aiOnlyWelcomeBullet3')}</li>
					</Box>
				</>
			}
			primaryButtonText={t('Get started now')}
			onPrimaryClick={closeDialog}
		/>
	);
};

export default AiOnlyWelcomeDialog;
